import { Accommodation, Activity, Package, User, DashboardStats, Food } from '../types';

export const mockAccommodations: Accommodation[] = [
  {
    id: '1',
    name: 'Le Renard',
    type: 'chalet',
    capacity: 4,
    amenities: ['foyer', 'quai_privé', 'cuisine_équipée', 'terrasse'],
    location: 'lac',
    pricePerNight: 180,
    images: ['/images/renard-1.jpg', '/images/renard-2.jpg'],
    description: 'Chalet rustique au bord du lac avec quai privé et foyer extérieur.',
    isAvailable: true
  },
  {
    id: '2',
    name: 'Le Lynx',
    type: 'chalet',
    capacity: 6,
    amenities: ['foyer', 'quai_partagé', 'cuisine_équipée', 'terrasse', 'barbecue'],
    location: 'lac',
    pricePerNight: 220,
    images: ['/images/lynx-1.jpg', '/images/lynx-2.jpg'],
    description: 'Chalet spacieux parfait pour les familles avec vue panoramique sur le lac.',
    isAvailable: true
  },
  {
    id: '3',
    name: 'La Perdrix',
    type: 'chalet',
    capacity: 2,
    amenities: ['foyer', 'quai_privé', 'cuisine_équipée'],
    location: 'forêt',
    pricePerNight: 150,
    images: ['/images/perdrix-1.jpg'],
    description: 'Chalet intime en forêt, idéal pour un séjour romantique.',
    isAvailable: true
  },
  {
    id: '4',
    name: 'Le Loup',
    type: 'chalet',
    capacity: 8,
    amenities: ['foyer', 'quai_privé', 'cuisine_équipée', 'terrasse', 'barbecue', 'salle_jeux'],
    location: 'lac',
    pricePerNight: 280,
    images: ['/images/loup-1.jpg', '/images/loup-2.jpg'],
    description: 'Grand chalet de luxe avec toutes les commodités pour les grands groupes.',
    isAvailable: true
  },
  {
    id: '5',
    name: 'Yourte',
    type: 'yourte',
    capacity: 4,
    amenities: ['foyer', 'quai_partagé', 'cuisine_commune'],
    location: 'forêt',
    pricePerNight: 120,
    images: ['/images/yourte-1.jpg'],
    description: 'Expérience unique en yourte avec vue sur la forêt boréale.',
    isAvailable: true
  },
  {
    id: '6',
    name: 'Le Huard',
    type: 'chalet',
    capacity: 3,
    amenities: ['foyer', 'quai_privé', 'cuisine_équipée'],
    location: 'lac',
    pricePerNight: 160,
    images: ['/images/huard-1.jpg'],
    description: 'Chalet compact au bord de l\'eau avec accès direct au lac.',
    isAvailable: false
  },
  {
    id: '7',
    name: 'La Bécasse',
    type: 'chalet',
    capacity: 5,
    amenities: ['foyer', 'quai_partagé', 'cuisine_équipée', 'terrasse'],
    location: 'mixte',
    pricePerNight: 200,
    images: ['/images/becasse-1.jpg'],
    description: 'Chalet entre lac et forêt, parfait pour les amateurs de nature.',
    isAvailable: true
  },
  {
    id: '8',
    name: 'L\'Original',
    type: 'chalet',
    capacity: 6,
    amenities: ['foyer', 'quai_privé', 'cuisine_équipée', 'terrasse', 'barbecue'],
    location: 'lac',
    pricePerNight: 240,
    images: ['/images/original-1.jpg'],
    description: 'Chalet premium avec vue exceptionnelle et toutes les commodités.',
    isAvailable: true
  },
  {
    id: '9',
    name: 'Rangée A',
    type: 'unite_rangée',
    capacity: 4,
    amenities: ['foyer', 'quai_partagé', 'cuisine_équipée'],
    location: 'lac',
    pricePerNight: 140,
    images: ['/images/rangee-a-1.jpg'],
    description: 'Unité en rangée face au lac, accès rapide aux quais.',
    isAvailable: true
  },
  {
    id: '10',
    name: 'Rangée B',
    type: 'unite_rangée',
    capacity: 4,
    amenities: ['foyer', 'quai_partagé', 'cuisine_équipée'],
    location: 'lac',
    pricePerNight: 145,
    images: ['/images/rangee-b-1.jpg'],
    description: 'Unité en rangée voisine, confortable pour petites familles.',
    isAvailable: true
  }
];

export const mockActivities: Activity[] = [
  {
    id: '1',
    name: 'Pêche au doré',
    type: 'été',
    description: 'Pêche guidée au doré jaune sur nos lacs privés',
    price: 80,
    duration: '4 heures',
    capacity: 4,
    equipment: ['canne à pêche', 'appâts', 'gilet de sauvetage'],
    isAvailable: true,
    openingPeriods: [
      { season: 'Été', startDate: '2026-06-01', endDate: '2026-08-31' }
    ],
    sales: 45,
    marketingLabels: ['family', 'couple'],
    pageDescription: 'Une expérience de pêche inoubliable sur nos lacs privés',
    zoneInMap: 'Zone A - Lac principal'
  },
  {
    id: '2',
    name: 'Kayak',
    type: 'été',
    description: 'Location de kayak pour explorer les lacs',
    price: 25,
    duration: 'journée',
    capacity: 1,
    equipment: ['kayak', 'pagaie', 'gilet de sauvetage'],
    isAvailable: true,
    openingPeriods: [
      { season: 'Été', startDate: '2026-05-15', endDate: '2026-09-30' }
    ],
    sales: 120,
    marketingLabels: ['family', 'couple'],
    pageDescription: 'Explorez nos magnifiques lacs en kayak',
    zoneInMap: 'Zone B - Quai principal'
  },
  {
    id: '3',
    name: 'Randonnée guidée',
    type: 'été',
    description: 'Randonnée en forêt avec guide naturaliste',
    price: 45,
    duration: '3 heures',
    capacity: 8,
    equipment: ['bottes de randonnée', 'jumelles'],
    isAvailable: true,
    openingPeriods: [
      { season: 'Été', startDate: '2026-05-01', endDate: '2026-10-31' },
      { season: 'Automne', startDate: '2026-09-01', endDate: '2026-11-30' }
    ],
    sales: 78,
    marketingLabels: ['family', 'corporate'],
    pageDescription: 'Découvrez la faune et la flore avec nos guides experts',
    zoneInMap: 'Zone C - Sentiers forestiers'
  },
  {
    id: '4',
    name: 'Chasse au chevreuil',
    type: 'automne',
    description: 'Chasse guidée au chevreuil en forêt',
    price: 150,
    duration: 'journée',
    capacity: 2,
    equipment: ['arme de chasse', 'vêtements de camouflage'],
    isAvailable: true,
    openingPeriods: [
      { season: 'Automne', startDate: '2026-09-15', endDate: '2026-12-15' }
    ],
    sales: 12,
    marketingLabels: ['couple'],
    pageDescription: 'Chasse guidée professionnelle en forêt boréale',
    zoneInMap: 'Zone D - Secteur chasse'
  },
  {
    id: '5',
    name: 'Ski de fond',
    type: 'hiver',
    description: 'Pistes de ski de fond entretenues',
    price: 20,
    duration: 'journée',
    capacity: 1,
    equipment: ['skis', 'bâtons', 'bottes'],
    isAvailable: true,
    openingPeriods: [
      { season: 'Hiver', startDate: '2026-12-01', endDate: '2027-03-31' }
    ],
    sales: 95,
    marketingLabels: ['family', 'couple'],
    pageDescription: 'Parcourez nos pistes de ski de fond entretenues',
    zoneInMap: 'Zone E - Pistes nordiques'
  },
  {
    id: '6',
    name: 'Pêche sur glace',
    type: 'hiver',
    description: 'Pêche sur glace avec guide expérimenté',
    price: 60,
    duration: '4 heures',
    capacity: 4,
    equipment: ['perceuse à glace', 'appâts', 'abri'],
    isAvailable: true,
    openingPeriods: [
      { season: 'Hiver', startDate: '2026-12-15', endDate: '2027-03-15' }
    ],
    sales: 34,
    marketingLabels: ['family'],
    pageDescription: 'Expérience unique de pêche sur glace',
    zoneInMap: 'Zone F - Lac gelé'
  }
];

export const mockPackages: Package[] = [
  {
    id: '1',
    name: 'Forfait Pêche Familiale',
    description: '2 nuits + pêche guidée + kayak pour toute la famille',
    products: [
      { id: '2', type: 'stay', pricingType: 'custom', customPrice: 200 },
      { id: '4', type: 'stay', pricingType: 'custom', customPrice: 220 },
      { id: '1', type: 'activity', pricingType: 'free' },
      { id: '2', type: 'activity', pricingType: 'discount', discountPercentage: 20 }
    ],
    price: 450,
    duration: 2,
    isAvailable: true
  },
  {
    id: '2',
    name: 'Weekend Romantique',
    description: '2 nuits en chalet intime + randonnée + dîner aux chandelles',
    products: [
      { id: '3', type: 'stay', pricingType: 'custom', customPrice: 150 },
      { id: '3', type: 'activity', pricingType: 'free' },
      { id: '3', type: 'food', pricingType: 'discount', discountPercentage: 15 }
    ],
    price: 320,
    duration: 2,
    isAvailable: true
  },
  {
    id: '3',
    name: 'Aventure Hivernale',
    description: '3 nuits + ski de fond + pêche sur glace + yourte',
    products: [
      { id: '5', type: 'stay', pricingType: 'custom', customPrice: 180 },
      { id: '4', type: 'activity', pricingType: 'free' },
      { id: '5', type: 'activity', pricingType: 'discount', discountPercentage: 25 }
    ],
    price: 380,
    duration: 3,
    isAvailable: true
  }
];

export const mockUser: User = {
  id: '1',
  email: 'client@example.com',
  firstName: 'Jean',
  lastName: 'Dupont',
  phone: '514-123-4567',
  role: 'client',
  preferences: {
    language: 'fr',
    notifications: true
  }
};

export const mockManagerUser: User = {
  id: '2',
  email: 'manager@pignonrouge.com',
  firstName: 'Marie',
  lastName: 'Tremblay',
  phone: '418-987-6543',
  role: 'manager',
  preferences: {
    language: 'fr',
    notifications: true
  }
};

export const mockStaffUser: User = {
  id: '3',
  email: 'staff@pignonrouge.com',
  firstName: 'Émile',
  lastName: 'Roy',
  phone: '581-555-0101',
  role: 'staff',
  preferences: {
    language: 'fr',
    notifications: true,
  },
};

export const mockFoodItems: Food[] = [
  { id: '1', name: 'Breakfast Package', category: 'Meal', price: 25, available: true, stock: 50 },
  { id: '2', name: 'Lunch Box', category: 'Meal', price: 20, available: true, stock: 30 },
  { id: '3', name: 'Dinner Set', category: 'Meal', price: 35, available: true, stock: 40 },
  { id: '4', name: 'Snack Pack', category: 'Snack', price: 10, available: true, stock: 100 },
  { id: '5', name: 'Beverage Pack', category: 'Beverage', price: 15, available: false, stock: 0 },
];

export const mockDashboardStats: DashboardStats = {
  totalReservations: 156,
  occupancyRate: 78,
  revenue: 45600,
  upcomingCheckIns: 12,
  maintenanceAlerts: 3
};

